import { render, staticRenderFns } from "./PanelCompetitionSettingStoper.vue?vue&type=template&id=06ce337a&scoped=true&"
import script from "./PanelCompetitionSettingStoper.vue?vue&type=script&lang=js&"
export * from "./PanelCompetitionSettingStoper.vue?vue&type=script&lang=js&"
import style0 from "./PanelCompetitionSettingStoper.vue?vue&type=style&index=0&id=06ce337a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ce337a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('06ce337a')) {
      api.createRecord('06ce337a', component.options)
    } else {
      api.reload('06ce337a', component.options)
    }
    module.hot.accept("./PanelCompetitionSettingStoper.vue?vue&type=template&id=06ce337a&scoped=true&", function () {
      api.rerender('06ce337a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PanelCompetitionSettingStoper.vue"
export default component.exports